import { Component, OnInit } from "@angular/core";
import { saveAs } from "file-saver";
import * as moment from "moment";

import { SAML } from "@impulse/sdp-shared-models";

import { SamlWizardService } from "../saml-wizard.service";
import { TranslateService } from "../../../../common/translate/translate.service";
import { AbstractWizardStepComponent } from "../../../wizard-dialog/abstract-wizard-step.component";
import { SamlSelectIdpComponent } from "../saml-select-idp/saml-select-idp.component";
import { SamlUploadComponent } from "../saml-upload/saml-upload.component";

@Component({
	templateUrl: "./saml-download.component.html"
})
export class SamlDownloadComponent extends AbstractWizardStepComponent<void> implements OnInit {
	private applicationName = "";
	public isDataLoaded = false;
	public isDownloading = false;
	public readonly downloadIcon = { type: "material", name: "file_download", cssClass: "sdp-saml-wizard-download-button-icon" };
	public readonly copyIcon = { type: "material", name: "content_copy", cssClass: "sdp-text-copy-icon" };

	public idpOption: SAML.ServiceProvider.IDPOptions.Field[] = [];
	public metadata!: SAML.ServiceProvider.IDPOptions.Field;

	constructor(
		private service: SamlWizardService,
		private translateService: TranslateService
	) {
		super();
	}

	public async ngOnInit() {
		this.isDataLoaded = false;
		this.applicationName = this.translateService.translate("application.title");
		this.idpOption = await this.service.getIdentityProviderOption(this.service.identityProvider.name);

		// You can download a metadata file or copy fields and download a cert file
		// This pulls the metadata file out of the dynamic fields that will be displayed and makes
		// it its own entity
		const metadataIndex = this.idpOption.findIndex((option, i) => {
			return option.displayName === "Metadata File";
		});

		this.metadata = this.idpOption[metadataIndex];
		this.idpOption.splice(metadataIndex, 1);
		this.isDataLoaded = true;
	}

	public download(value: SAML.ServiceProvider.IDPOptions.Field) {
		if (value.type === "download") {
			this.isDownloading = true;
			this.service.getUrl(value.url!).subscribe((data) => {
				const blob = new Blob([data], { type: value.mimeType });
				this.isDownloading = false;
				saveAs(blob, value.filename);
			});
		}
	}

	public getDate(value: number) {
		const expiry = moment(value);
		return expiry.format("MMM DD, YYYY");
	}

	public get title() {
		return "saml.wizard.download.title";
	}

	public get description() {
		const args = {
			applicationTitle: this.applicationName,
			samlIdp: this.service.identityProvider.name
		};

		return this.translateService.translate("saml.wizard.download.description", args);
	}

	public get nextStep() {
		return SamlUploadComponent;
	}

	public get previousStep() {
		return SamlSelectIdpComponent;
	}

	public get isFormValid() {
		return true;
	}

	public async performPrevious() { }

	public async performNext() { }

	public get showProgressBar() {
		return !this.isDataLoaded || this.isDownloading;
	}
}
